import { useMemo } from 'react'
import { CountryForwardingPrice, Mail } from 'common/types/responses'
import { MailActionType } from 'common/types/enum'
import { MailEnvelopeType } from 'common/types/enum'

export default function (
  mail: Mail[] | undefined,
  actionType: MailActionType | undefined,
  forwardingPrices?: CountryForwardingPrice[],
  countryCode?: string,
) {
  return useMemo(() => {
    return getActionTotal(mail, actionType, forwardingPrices, countryCode)
  }, [mail, actionType, forwardingPrices, countryCode])
}

export const getForwardingPrice = (
  forwardingPrices: CountryForwardingPrice[],
  countryCode: string,
  envelopeType?: MailEnvelopeType,
): number | undefined => {
  const countryPricing = forwardingPrices.find(
    (p) => p.country_code === countryCode,
  )
  if (!countryPricing) {
    return undefined
  }
  const isLarge = envelopeType === MailEnvelopeType.C4
  if (isLarge) {
    return (
      (countryPricing.large_letter_cost_in_pence ?? 0) +
      (countryPricing.large_letter_handling_fee_pence ?? 0)
    )
  }
  return (
    (countryPricing.small_letter_cost_in_pence ?? 0) +
    (countryPricing.small_letter_handling_fee_pence ?? 0)
  )
}

export const getActionTotal = (
  mail: Mail[] | undefined,
  actionType: MailActionType | undefined,
  forwardingPrices?: CountryForwardingPrice[],
  countryCode?: string,
) => {
  let total = 0
  const items: { mail: Mail; price: number }[] = []

  const useCountryPricing =
    actionType === MailActionType.FORWARD &&
    !!forwardingPrices?.length &&
    !!countryCode

  mail?.map((v) => {
    const action = v.actions?.find((v) => v.action_type === actionType)
    const price = useCountryPricing
      ? (getForwardingPrice(forwardingPrices!, countryCode!, v.envelope_type) ??
        action?.price ??
        0)
      : (action?.price ?? 0)
    items.push({ mail: v, price })
    total += price
  })
  return { items, total }
}
